function sortSwatches() {
  const swatchGroups = document.querySelectorAll('.swatches-type-products, .swatches-type-collections');

  swatchGroups.forEach(group => {
    if (group._isProcessing) return;
    group._isProcessing = true;

    let swatchList;
    
    if (group.classList.contains('swatches-type-products')) {
      swatchList = group.querySelector('.swatch-view');
    } else {
      const navigableWrapper = group.querySelector('.swatch-navigable');
      swatchList = navigableWrapper ? navigableWrapper.querySelector('.swatch-view') : null;
    }
    
    if (!swatchList) {
      group._isProcessing = false;
      return;
    }

    const swatches = Array.from(swatchList.children);
    const hasUnavailable = swatches.some(s => s.classList.contains('swatch-item-unavailable'));
    
    if (hasUnavailable) {
      if (group._swatchObserver) {
        group._swatchObserver.disconnect();
      }

      swatches.sort((a, b) => {
        const aUnavailable = a.classList.contains('swatch-item-unavailable');
        const bUnavailable = b.classList.contains('swatch-item-unavailable');
        return aUnavailable - bUnavailable;
      });

      const fragment = document.createDocumentFragment();
      swatches.forEach(s => fragment.appendChild(s));
      swatchList.innerHTML = '';
      swatchList.appendChild(fragment);

      if (group._swatchObserver) {
        setTimeout(() => {
          group._swatchObserver.observe(swatchList, { 
            childList: true, 
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
          });
        }, 100);
      }
    }

    group._isProcessing = false;
  });
}

function sortModalVariants() {
  const variantWrappers = document.querySelectorAll('.variant-wrapper[data-type="button"]');

  variantWrappers.forEach(wrapper => {
    if (wrapper._isProcessing) return;
    wrapper._isProcessing = true;

    const fieldset = wrapper.querySelector('.variant-input-wrap');
    if (!fieldset) {
      wrapper._isProcessing = false;
      return;
    }

    const variantInputs = Array.from(fieldset.querySelectorAll('.variant-input'));
    const hasUnavailable = variantInputs.some(input => input.querySelector('.disabled'));
    
    if (hasUnavailable) {
      if (wrapper._modalObserver) {
        wrapper._modalObserver.disconnect();
      }

      variantInputs.sort((a, b) => {
        const aUnavailable = a.querySelector('.disabled') !== null;
        const bUnavailable = b.querySelector('.disabled') !== null;
        return aUnavailable - bUnavailable;
      });

      const fragment = document.createDocumentFragment();
      variantInputs.forEach(input => fragment.appendChild(input));
      fieldset.innerHTML = '';
      fieldset.appendChild(fragment);

      if (wrapper._modalObserver) {
        setTimeout(() => {
          wrapper._modalObserver.observe(fieldset, { 
            childList: true, 
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
          });
        }, 100);
      }
    }

    wrapper._isProcessing = false;
  });
}

function observeSwatches() {
  const swatchGroups = document.querySelectorAll('.swatches-type-products, .swatches-type-collections');

  swatchGroups.forEach(group => {
    if (group._swatchObserver) return;

    let targetElement;
    
    if (group.classList.contains('swatches-type-products')) {
      targetElement = group.querySelector('.swatch-view');
    } else {
      const navigableWrapper = group.querySelector('.swatch-navigable');
      targetElement = navigableWrapper ? navigableWrapper.querySelector('.swatch-view') : null;
    }
    
    if (!targetElement) return;

    group._swatchObserver = new MutationObserver((mutations) => {
      let shouldSort = false;
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          shouldSort = true;
          break;
        }
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          shouldSort = true;
          break;
        }
      }
      
      if (shouldSort && !group._isProcessing) {
        sortSwatches();
      }
    });

    group._swatchObserver.observe(targetElement, { 
      childList: true, 
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  });
}

function observeModalVariants() {
  const variantWrappers = document.querySelectorAll('.variant-wrapper[data-type="button"]');

  variantWrappers.forEach(wrapper => {
    if (wrapper._modalObserver) return;

    const fieldset = wrapper.querySelector('.variant-input-wrap');
    if (!fieldset) return;

    wrapper._modalObserver = new MutationObserver((mutations) => {
      let shouldSort = false;
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          shouldSort = true;
          break;
        }
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          shouldSort = true;
          break;
        }
      }
      
      if (shouldSort && !wrapper._isProcessing) {
        sortModalVariants();
      }
    });

    wrapper._modalObserver.observe(fieldset, { 
      childList: true, 
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  });
}

function waitForAllElements() {
  let initialized = false;
  
  const interval = setInterval(() => {
    const swatchGroups = document.querySelectorAll('.swatches-type-products, .swatches-type-collections');
    const modalVariants = document.querySelectorAll('.variant-wrapper[data-type="button"]');
    
    if ((swatchGroups.length || modalVariants.length) && !initialized) {
      initialized = true;
      clearInterval(interval);
      
      // Initial sort
      sortSwatches();
      sortModalVariants();
      
      // Set up observers
      observeSwatches();
      observeModalVariants();
      
      // Body observer for dynamic content
      const bodyObserver = new MutationObserver((mutations) => {
        let newElementsFound = false;
        
        for (const mutation of mutations) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            for (const node of mutation.addedNodes) {
              if (node.nodeType === 1) {
                // Check for swatch groups
                if (node.classList?.contains('swatches-type-products') || 
                    node.classList?.contains('swatches-type-collections') ||
                    node.querySelector?.('.swatches-type-products, .swatches-type-collections')) {
                  newElementsFound = true;
                  break;
                }
                // Check for modal variants
                if (node.classList?.contains('variant-wrapper') || 
                    node.querySelector?.('.variant-wrapper[data-type="button"]')) {
                  newElementsFound = true;
                  break;
                }
              }
            }
          }
          if (newElementsFound) break;
        }
        
        if (newElementsFound) {
          setTimeout(() => {
            sortSwatches();
            sortModalVariants();
            observeSwatches();
            observeModalVariants();
          }, 500);
        }
      });
      
      bodyObserver.observe(document.body, { 
        childList: true, 
        subtree: true 
      });
    }
  }, 200);
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', waitForAllElements);
} else {
  waitForAllElements();
}